module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/portofolio-studysmart.json
// module id = 853
// module chunks = 237178804904609